export default {
  name: '',
  domain: '',
  analytics: {
    google_conversion_id: '943617023',
    google_analytics_sandbox_id: 'UA-11834194-31'
  },
  google_tag_manager_id: 'GTM-585RXMV',
  google_optimize_container_id: 'GTM-5VPWWP',
  ui: {
    default_user_image_path: '/images/default-user.jpg',
    item_list_views: [
      {
        value: 'list',
        label: 'List'
      },
      {
        value: 'grid',
        label: 'Grid'
      }
    ],
    image_preview_ratio: 1,
    item_small_preview_paths: [
      'icon_with_landscape_preview.icon_url',
      'icon_with_square_preview.icon_url',
      'icon_with_video_preview.icon_url',
      'icon_with_audio_preview.icon_url',
      'icon_with_thumbnail_preview.icon_url',
      'thumbnail_preview.small_url',
      'icon_preview.icon_url'
    ],
    featured_hero_item_viewtype: 'list'
  },
  common: {
    search_page_size: 30,
    max_pages_count: 60
  },
  features: {
    /**
     * @description Decide whether to show sign up modal or render the sign up page.
     * @author Fraser Xu
     * @expires
     */
    'modal:signup': false,

    /**
     * @description Enables usage of external from shopfront frontent repo, shopfront api
     * @author Pawel Galazka and Fraser Xu
     * @expires when all endpoints migrated to /shopfront-api
     */
    'shopfront-api': false,

    /**
     * @description Global swither to turn off Cookiebot
     * @author Fraser Xu
     * @expires
     */
    turnOffCookiebot: false
  },
  asset_type: 'item',
  search_query: {
    default_sort_by: 'sales',
    default_sort_by_options: [
      {
        label: 'Best match',
        value: 'relevance'
      },
      {
        label: 'Best sellers',
        value: 'sales'
      },
      {
        label: 'Newest',
        value: 'date'
      },
      {
        label: 'Best rated',
        value: 'rating'
      },
      {
        label: 'Trending',
        value: 'trending'
      },
      {
        label: 'Price',
        value: ['price-asc', 'price-desc']
      }
    ]
  },
  recommendations_limit: 8,
  show_category_in_selected_filters: false,
  min_price: 100,
  minimum_items_for_category_page: 300,
  homepage: {
    newest_items_page_size: 40,
    newest_items_square: true
  },
  displayCategoryPage: true
}
